export default "__VITE_ASSET__D9tfX4PK__"